import { render, staticRenderFns } from "./AlldateEchats.vue?vue&type=template&id=70110044&scoped=true&"
import script from "./AlldateEchats.vue?vue&type=script&lang=js&"
export * from "./AlldateEchats.vue?vue&type=script&lang=js&"
import style0 from "./AlldateEchats.vue?vue&type=style&index=0&id=70110044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70110044",
  null
  
)

export default component.exports